import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import volumeHighSvg from '../../../assets/images/icons/volume-high.svg'
import volumeOffSvg from '../../../assets/images/icons/volume-off.svg'
import { userSettingsAtom } from '../../../store/atoms'
import { Icon, Input, ToggleSwitch } from '../../atoms'
import {
  rangeInput,
  settingOption,
  settingsBlock,
  settingsContent,
} from './index.css'

export const GameSettings = () => {
  const { t } = useTranslation()
  const [userSettings, setUserSettings] = useAtom(userSettingsAtom)

  return (
    <div className={settingsBlock}>
      <div className={settingsContent}>
        <div className={settingOption}>
          <Icon
            src={userSettings.volume ? volumeHighSvg : volumeOffSvg}
            alt={t('settings.setting.volume')}
            onClick={() =>
              setUserSettings((prev) => ({
                ...prev,
                volume: userSettings.volume ? 0 : 100,
              }))
            }
          />
          <Input
            value={userSettings.volume}
            type='range'
            min={0}
            max={100}
            step={1}
            className={rangeInput}
            onChange={(volume) =>
              setUserSettings((prev) => ({
                ...prev,
                volume: volume ?? prev.volume,
              }))
            }
          />
        </div>
        <div className={settingOption}>
          <span>{t('settings.setting.valuesInBb')}</span>
          <ToggleSwitch
            checked={userSettings.valuesInBigBlinds}
            onChange={(e) =>
              setUserSettings((prev) => ({
                ...prev,
                valuesInBigBlinds: e.target.checked,
              }))
            }
          />
        </div>
        <div className={settingOption}>
          <span>{t('settings.setting.gameChat')}</span>
          <ToggleSwitch
            checked={userSettings.showGameChat}
            onChange={(e) =>
              setUserSettings((prev) => ({
                ...prev,
                showGameChat: e.target.checked,
              }))
            }
          />
        </div>
      </div>
    </div>
  )
}
